function filterJobs(locationSelect, careerSelect) {
  const location = locationSelect?.value || '';
  const department = careerSelect?.value || '';
  
  // Dispatch custom event that the jobs section will listen to
  window.dispatchEvent(new CustomEvent('careers:filter', {
    detail: { location, department }
  }));
}

document.addEventListener('DOMContentLoaded', function() {
  const filters = document.querySelector('.careers-filters');
  if (!filters){
    return;
  } 
  
  const locationSelect = filters.querySelector('select[name="location"]');
  const careerSelect = filters.querySelector('select[name="career_type"]');
  
  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      filterJobs(locationSelect, careerSelect);
    });
  }
  if (careerSelect) {
    careerSelect.addEventListener('change', function() {
      filterJobs(locationSelect, careerSelect);
    });
  }
});